module.exports = __webpack_public_path__ + "media/images/ADDress_logo_white-604f741ffb2814dae7402b24b7b025f6.svg";